module novaCmsWidgets {
  export interface IConfirmDialogOptions {
    title?: string;
    width?: string | number;
    contentTemplate?: string;
    contentData?: {};
    message?: string;
    positiveText?: string;
    negtiveText?: string;
  }

  export class ConfirmDialogOptions implements IConfirmDialogOptions {
    name = 'ConfirmDialog';
    title = 'NovaCMS';
    width = '250px;';
    contentData = {};
    message = '';
    positiveText = 'Tak';
    negtiveText = 'Nie';
    contentTemplate = `
      <div class='popupMessage'></div>
        <div class='dialog-buttons'>
          <input type='button' class='confirm_yes k-button' value='Tak' style='width: 70px' />
          <input type='button' class='confirm_no k-button' value='Nie' style='width: 70px' />
      </div>`;
  }

  export class ConfirmDialog extends kendo.ui.Widget {
    options: ConfirmDialogOptions;
    private _dialogWindow: kendo.ui.Window;
    constructor(element: Element, options: IConfirmDialogOptions) {
      super(element, options);
    }

    showDialog(): JQuery.Promise<boolean> {
      const dfd = jQuery.Deferred();
      let result = false;
      const content = kendo.template(this.options.contentTemplate, { useWithBlock: false })(this.options.contentData);

      this._dialogWindow = $('<div id="novaConfirmDialog"></div>')
        .appendTo('body')
        .kendoWindow({
          width: this.options.width,
          modal: true,
          title: this.options.title,
          visible: false,
          close: (e) => {
            dfd.resolve(result);
          },
          deactivate: (e) => {
            this._dialogWindow.destroy();
            this.destroy();
          }
        }).data('kendoWindow');
      this._dialogWindow.content(content).center().open();

      $('.popupMessage').html(this.options.message);

      $('#novaConfirmDialog .confirm_yes').val(this.options.positiveText);
      $('#novaConfirmDialog .confirm_no').val(this.options.negtiveText);

      $('#novaConfirmDialog .confirm_no').click(() => {
        $('#novaConfirmDialog').data('kendoWindow').close();
      });

      $('#novaConfirmDialog .confirm_yes').click(() => {
        result = true;
        $('#novaConfirmDialog').data('kendoWindow').close();
      });

      return dfd.promise();
    }
  }

  ConfirmDialog.fn = ConfirmDialog.prototype;
  ConfirmDialog.fn.options = new ConfirmDialogOptions();
  kendo.ui.plugin(ConfirmDialog);
}
interface JQuery {
  kendoConfirmDialog(options?: novaCmsWidgets.IConfirmDialogOptions): JQuery;
  data(key: 'kendoalaConfirmDialog'): novaCmsWidgets.ConfirmDialog;
}
